module.exports = __webpack_public_path__ + "media/images/photo/community_man-558295ada231a5e56af64b95a3a29666.png";